import { render, staticRenderFns } from "./CompletionScreenPoint.vue?vue&type=template&id=4f6584e0&scoped=true&"
import script from "./CompletionScreenPoint.vue?vue&type=script&lang=js&"
export * from "./CompletionScreenPoint.vue?vue&type=script&lang=js&"
import style0 from "./CompletionScreenPoint.vue?vue&type=style&index=0&id=4f6584e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6584e0",
  null
  
)

export default component.exports